import { render } from "./MaintenanceNotifications.vue?vue&type=template&id=6d2723b8"
import script from "./MaintenanceNotifications.vue?vue&type=script&lang=js"
export * from "./MaintenanceNotifications.vue?vue&type=script&lang=js"

import "./MaintenanceNotifications.vue?vue&type=style&index=0&id=6d2723b8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__